module.exports = __webpack_public_path__ + "static/img/i-step1.87324c16.png";